import { Navigate, Route, Routes } from "react-router-dom"
import { Home } from "./views"
import { Layout } from "./layouts"

function App() {

	return (
		<>
			<Routes>
				<Route index element={<Layout><Home /></Layout>} />
				{/* <Route path="/nosotros" element={<Layout><About /></Layout>} />
				<Route path="/servicios" element={<Layout><Services /></Layout>} />
				<Route path="/contacto" element={<Layout><Contact /></Layout>} /> */}
				<Route path="*" element={<Navigate to="/" />} />
			</Routes>
		</>
	)
}

export default App
